<template>
    <bareme-etape-4 :resultat="resultat"></bareme-etape-4>
</template>

<script>

import BaremeEtape4 from '@/components/bareme/etapes/Etape4.vue';

export default {
  name: 'BaremeAjusteResultat',
  components: { BaremeEtape4 },
  props: {
    resultat: Object,
  },
};
</script>

<style scoped>

</style>
